(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/cookies-info/assets/javascripts/cookie-info.js') >= 0) return;  svs.modules.push('/components/components/cookies-info/assets/javascripts/cookie-info.js'); 
'use strict';

const logger = svs.core.log.getLogger('component:cookies_info');
svs.components.cookies_info.cookieInfo = function () {
  return {
    show: cookieDialogInfoObject => {
      logger.info('Show cookie information dialog for visitor');
      const dialog = new svs.components.dialog.Confirm({
        actions: [{
          title: 'Anpassa',
          callback: () => {
            svs.components.cookies_info.select.show(cookieDialogInfoObject);
            dialog.close();
          }
        }, {
          title: 'Acceptera',
          callback: () => {
            const cookieConfig = {
              ad: cookieDialogInfoObject.isTrackingAllowed,
              personalized: true,
              analytics: true,
              provision: true
            };
            svs.core.cookie_consent.dataHandler.setConsent(cookieConfig).then(msg => {
              logger.info("Cookie consent info sent to data layer. ".concat(msg));
              const personalizedConsent = new svs.components.analytics.customEvents.PersonalizedConsentChanged(true);
              personalizedConsent.track();
              const analyticsConsent = new svs.components.analytics.customEvents.AnalyticsConsentChanged(true);
              analyticsConsent.track();
              location.reload(true);
              return true;
            }).catch(err => {
              logger.warn("Unable to send cookie consent info to datalayer. ".concat(err));
            });
            dialog.close();
          }
        }],
        area: svs.components.dialog.area.POPUP,
        branding: cookieDialogInfoObject.branding,
        icon: 'gdpr-cookies',
        message: [{
          align: svs.components.dialog.message.align.LEFT,
          text: svs.components.cookies_info.templates.cookie_info_dialog({
            corporateName: cookieDialogInfoObject.corporateName,
            corporateUrl: cookieDialogInfoObject.corporateUrl,
            cookieInfoUrl: cookieDialogInfoObject.cookieInfoUrl,
            personalDataUrl: cookieDialogInfoObject.personalDataUrl,
            isTrackingAllowed: cookieDialogInfoObject.isTrackingAllowed
          }),
          type: svs.components.dialog.message.TEXT
        }],
        title: 'Vi använder cookies',
        type: svs.components.dialog.type.DEFAULT
      });
      svs.components.dialog.api.add(dialog);
    }
  };
}();
 })(window);